/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser, permissionTree?: any } | undefined) {
  const { currentUser, permissionTree } = initialState ?? {};
  // // Helper function to recursively search for a name in the allowed structure
  // const isNameInAllowed = (items: any[], targetName: string): boolean => {
  //   for (const item of items) {
  //     // Check current level name
  //     if (item.name === targetName) {
  //       return true;
  //     }
  //     // Recursively check children
  //     if (item.children && item.children.length > 0) {
  //       if (isNameInAllowed(item.children, targetName)) {
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // };

  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    normalRouteFilter: () => {
      return true;
    },
  };
}
